import {IPreMatchState, IPreMatchStatistic} from "./types";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import { API_PRE_MATCH } from "../../../services/api/api.urls";
import { api } from "../../../services/api/api.service";
import { toastr } from "react-redux-toastr";
import { COMPANY_ABBR } from "../../../common/constants/company";
import { TryCatch } from "../../../services/TryCatch";

const initialState: IPreMatchState = {
    gameStatistic: {} as IPreMatchStatistic,
    isReady: false,
    isDataDownloaded: false
};

export const getPreMatchStats = createAsyncThunk<IPreMatchStatistic, void, { rejectValue: string }>(
    'preMatch/get',
    async (_, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(API_PRE_MATCH).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, "Pre match info failed.")
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const preMatchSlice = createSlice({
    name: 'preMatch',
    reducers: {},
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getPreMatchStats.pending, (state) => {
                state.isDataDownloaded = false;
                state.isReady = false;
            })
            .addCase(getPreMatchStats.fulfilled, (state, action) => {
                state.gameStatistic = action.payload;
                state.isDataDownloaded = true;
                state.isReady = true;

            })
            .addCase(getPreMatchStats.rejected, (state) => {
                state.isDataDownloaded = true;
                state.isReady = true;
            })
    }})

export default preMatchSlice.reducer;
